import { snackbar } from "@mobiscroll/react5";
import { getQuery } from "src/components/ApolloConnection/ApolloProviderComponent";
import { LIST_CLINIC_DELETE_REQUEST } from "src/components/graphql/GraphQLquery";

export async function listClinicDeletionRequests() {

    try {
        const response = await getQuery(LIST_CLINIC_DELETE_REQUEST);

        if (!response || response.errors) {
            throw new Error(response?.errors?.[0]?.message || "Failed to fetch clinic deletion requests");
        }

        const result = response?.data?.listClinicDeletionRequests;

        if (result?.statusCode && result.statusCode >= 400) {
            throw new Error(result?.message || "Failed to fetch clinic deletion requests");
        }

        if (result?.data) {
            return result.data;
        }

        throw new Error("No data found in clinic deletion requests");
    } catch (e) {
        snackbar({ message: e.message || "Error fetching clinic deletion requests. Try again", color: "danger", });
        console.error("Error at fetching Clinic deletion requests ", e);
        // return [];
        throw e;
    }
}